module.exports = __webpack_public_path__ + "teqbahn-assets/media/TeqbahnLabs1.ce4e88e5.png";